<template>
  <generic-container
    :searchable="false"
    :show_plus="true"
    icon="stream"
    :title="$t('arguments')"
    @add="add"
    class="ui form"
  >
    <div
      class="fields"
      v-for="(arg, index) in args"
      v-bind:key="index"
      style="margin-bottom: 10px"
    >
      <div class="eight wide column field">
        <label for v-if="index == 0">{{ $t("name") }}</label>
        <input type="text" v-model="args[index].name" name="name" />
      </div>
      <div class="seven wide column field">
        <label for v-if="index == 0">{{ $t("type") }}</label>
        <select
          class="ui dropdown"
          ref="type_dropdown"
          name="type"
          v-model="args[index].type"
        >
          <option value>{{ $t("select one") }}</option>
          <option value="">{{ $t("simple") }}</option>
          <option
            :value="itm.uuid"
            v-for="(itm, idx) in $props.business_objects"
            :key="idx"
          >
            {{ itm.name }}
          </option>
        </select>
      </div>
      <div class="one column width field">
        <label for v-if="index == 0">{{ $t("actions") }}</label>
        <div class="ui mini icon red button" @click="remove(arg, index)">
          <i class="trash icon"></i>
        </div>
      </div>
    </div>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import filters from "@/filters";

export default {
  name: "ArgumentManagement",
  filters: filters,
  props: { human_task: Object, business_objects: Array },
  components: {
    GenericContainer,
  },
  data() {
    return {
      args: [],
    };
  },
  methods: {
    add() {
      let arg = {
        name: "",
        type: "",
      };
      this.args.push(arg);
    },
    remove(arg, index) {
      this.args.splice(index, 1);
    },
  },
  mounted() {
    let vm = this;
    setTimeout(function () {
      if (vm.$props.human_task.uuid) {
        vm.args = vm.$props.human_task.args || [];
      }
    }, 2000);
  },
  watch: {},
  updated() {
    let vm = this;
    window.jQuery(vm.$refs.type_dropdown).dropdown();
  },
};
</script>
